import * as THREE from 'three';
import type { Tickable } from '../engine/Game';
import type { Terrain } from './Terrain';

export class Water implements Tickable {
  readonly mesh: THREE.Mesh;
  private basePositions: Float32Array;

  constructor(terrain: Terrain) {
    const pond = terrain.getLandmarkPositions().pond;
    const geo = new THREE.CircleGeometry(11, 48, 0, Math.PI * 2);
    geo.rotateX(-Math.PI / 2);
    this.basePositions = (geo.attributes.position as THREE.BufferAttribute).array.slice() as Float32Array;

    const mat = new THREE.MeshStandardMaterial({
      color: '#9fd9ff',
      roughness: 0.2,
      metalness: 0.1,
      transparent: true,
      opacity: 0.85,
    });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.position.set(pond.x, -0.45, pond.z);
    this.mesh.receiveShadow = true;
  }

  tick(_dt: number, elapsed: number): void {
    const pos = this.mesh.geometry.attributes.position as THREE.BufferAttribute;
    const arr = pos.array as Float32Array;
    for (let i = 0; i < arr.length; i += 3) {
      const x = this.basePositions[i];
      const z = this.basePositions[i + 2];
      arr[i + 1] = Math.sin(x * 0.3 + elapsed * 1.4) * 0.06 + Math.cos(z * 0.25 + elapsed) * 0.05;
    }
    pos.needsUpdate = true;
  }
}
